import React from 'react';
import {
	getBackgroundColorClassName,
	getFontColorClassName,
} from '../../lib/getColorClassNames';
import { EasyStepsBlockValue } from '../../types/optimizely/blocks/easyStepsBlock';
import { CTAButton } from '../CTAButton/CTAButton';
import { EasyStepRowBlock } from '../EasyStepRowBlock/EasyStepRowBlock';
import { useEasyStepsBlockData } from './useEasyStepsBlockData';

const matrixOfSteps: number[] = [];

export const EasyStepsBlock = ({ contentLink }: EasyStepsBlockValue) => {
	const easyStepsRef = React.useRef<HTMLDivElement>(null);
	const data = useEasyStepsBlockData(contentLink.id);
	const backgroundColorClass = getBackgroundColorClassName(
		data?.backgroundColor,
	);
	const fontColorClass = getFontColorClassName(data?.fontColor);

	const ctaButtonHandler = () => {
		easyStepsRef.current?.scrollIntoView({ behavior: 'smooth' });
	};

	return (
		<>
			<section
				ref={easyStepsRef}
				className={`px-8 py-16 md:py-32 ${backgroundColorClass} ${fontColorClass}`}
				id={contentLink.id}
			>
				<div className="container">
					<h2 className="text-4xl">{data?.title}</h2>
				</div>
				{data?.rows.map((row, index) => {
					matrixOfSteps[index] = row.steps ?? 0;
					return (
						<EasyStepRowBlock
							listOfSteps={matrixOfSteps}
							index={index}
							{...row}
						/>
					);
				})}
			</section>
			{data?.showCTAButton ? (
				<CTAButton onClick={ctaButtonHandler} label={data?.ctaButtonLabel} />
			) : null}
		</>
	);
};
